import {Dimensions, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, grayscale, white} from '/theme/color/on.color';
import {alto, codGray, kimberlyLighter} from '/theme/color/secondary.color';

const height = Dimensions.get('window').height;

export const styles = StyleSheet.create({
  base: {},
  modalView: {
    height: height > 684 ? '30%' : '80%',
    backgroundColor: white,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
  },
  keyboardViewContainer: {
    paddingTop: 10,
  },
  modalBody: {
    lineHeight: 24,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: indent,
  },
  closeIcon: {
    fontSize: 20,
    color: grayscale,
    marginRight: indent * 0.5,
  },
  headerText: {
    fontSize: 16,
    fontWeight: '500',
    color: codGray,
  },
  inputContainer: {
    flexDirection: 'column',
  },
  inputText: {
    borderWidth: 1,
    borderColor: alto,
    backgroundColor: white,
    width: '100%',
    borderRadius: indent * 0.4,
    marginBottom: indent * 1,
    height: 40,
    paddingLeft: indent,
    color: codGray,
    paddingBottom: 5,
    fontWeight: '500',
  },
  modalFooter: {
    flexDirection: 'column',
    marginBottom: indent * 0.5,
  },
  buttonSave: {
    justifyContent: 'center',
    borderWidth: 1,
    borderColor: kimberlyLighter,
    width: '100%',
    borderRadius: indent * 0.4,
    marginTop: indent * 0.6,
    marginBottom: indent * 1,
    height: 40,
    fontWeight: '900',
  },
  buttonCancel: {
    color: denim,
    fontWeight: '900',
  },
});
